import React from 'react';
import { Card } from '@dopomogai/ui';

type Allocation = { label: string; percent: number };
type Props = { allocations?: Allocation[] };

const DEFAULTS: Allocation[] = [
  { label: 'Infrastructure', percent: 35 },
  { label: 'Data & Training', percent: 25 },
  { label: 'R&D', percent: 20 },
  { label: 'GTM', percent: 15 },
  { label: 'Reserve', percent: 5 },
];

export function UseOfFunds({ allocations = DEFAULTS }: Props) {
  return (
    <section className="max-w-6xl mx-auto px-6 py-8">
      <Card>
        <div className="p-4">
          <div className="text-xl font-extrabold mb-2">Where the money goes</div>
          <div className="grid md:grid-cols-5 gap-3">
            {allocations.map((a, i) => (
              <div key={i} className="border-2 border-black rounded-lg p-3 bg-white">
                <div className="text-xs text-slate-600">{a.label}</div>
                <div className="text-lg font-extrabold">{a.percent}%</div>
              </div>
            ))}
          </div>
          <div className="text-xs text-slate-600 mt-3">Budget allocations are indicative and may change.</div>
        </div>
      </Card>
    </section>
  );
}


